import axios from 'Services/axiosInterceptor';
import * as action_types from './constants';
import { externalBaseUrl } from '../../../../configs/constants';

export const getMonthlyReport = (page, limit, order, orderby, search = {}, load) => {
  load && load(true);
  let ordering = '';
  if (order == "ascend") {
    ordering = 'ASC'
  } else if (order == "descend") {
    ordering = 'DESC'
  }
  return async (dispatch) => {
    const {
      data: { data, meta },
    } = await axios.post(`${externalBaseUrl}/e-invoice/monthly-report`, {
      q: JSON.stringify({
        location_id_in: search?.outlet ? search?.outlet : [],
        date_lteq: search?.start_date,
        date_gteq: search?.end_date,
        e_invoice_status_eq: search?.e_invoice_status,
        s: `${orderby} ${ordering}`
      }),
      page: page,
      limit: limit
    });
    load && load(false);
    dispatch({
      type: action_types.INVOICE_MONTHLY_REPORT,
      data: data,
      meta: meta
    });
  };
};